const state = {
  token: localStorage.getItem('token'),
  refreshToken: localStorage.getItem('refreshToken')
}

const getters = {
  token (state) {
    return state.token
  },
  refreshToken (state) {
    return state.refreshToken
  }
}

const mutations = {
  SET_TOKEN (state, token) {
    state.token = token
  },
  SET_REFRESH_TOKEN (state, token) {
    state.refreshToken = token
  }
}

const actions = {
  loadToken ({ commit }) {
    commit('SET_TOKEN', localStorage.getItem('token'))
  },
  setToken ({ commit }, token) {
    localStorage.setItem('token', token)
    commit('SET_TOKEN', token)
  },
  removeToken ({ commit }) {
    const language = localStorage.getItem('language')
    const verticalNavMenuWidth = localStorage.getItem('verticalNavMenuWidth')
    localStorage.clear()
    localStorage.setItem('language', language)
    localStorage.setItem('verticalNavMenuWidth', verticalNavMenuWidth)
    commit('SET_TOKEN', null)
  },
  loadRefreshToken ({ commit }) {
    commit('SET_REFRESH_TOKEN', localStorage.getItem('refreshToken'))
  },
  setRefreshToken ({ commit }, token) {
    localStorage.setItem('refreshToken', token)
    commit('SET_REFRESH_TOKEN', token)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
